import { useState } from 'react';
import { T } from 'gt-react';
import { DownloadSimpleIcon } from '@phosphor-icons/react';

import { Button } from '@/components/ui/button';
import {
  flaggedDownloadFiles,
  type FlaggedDownloadFile,
} from '@/lib/daily-reports/flaggedDownloads';
import type { DailyReportSummary } from '@/lib/daily-reports/types';
import { triggerDownload } from 'src/lib/pricelist-utils';
import { DownloadFlaggedRowsDialog } from './DownloadFlaggedRowsDialog';

export function DailyReportsDownloadControls(props: {
  summary: DailyReportSummary;
  isAnalyzing: boolean;
}) {
  const [downloadFiles, setDownloadFiles] = useState<
    FlaggedDownloadFile[] | null
  >(null);

  if (props.summary.flaggedCount === 0) return null;

  return (
    <>
      <Button
        onClick={() => setDownloadFiles(flaggedDownloadFiles(props.summary))}
        disabled={props.isAnalyzing}
      >
        <DownloadSimpleIcon className="h-4 w-4" />
        <T context="button that downloads flagged daily report rows as CSV">
          Download Flagged Rows
        </T>
      </Button>
      <DownloadFlaggedRowsDialog
        files={downloadFiles ?? []}
        open={downloadFiles !== null}
        onOpenChange={(open) => {
          if (!open) setDownloadFiles(null);
        }}
        onConfirm={(files) => {
          for (const file of files) {
            triggerDownload(
              new Blob([file.body], { type: 'text/csv' }),
              file.fileName,
            );
          }
        }}
      />
    </>
  );
}
